// extracted by mini-css-extract-plugin
export default {"root":"LastCheckTable_root__O3zmi","bottomSection":"LastCheckTable_bottomSection__De7U8","bottomSectionLabel":"LastCheckTable_bottomSectionLabel__v08KE"};